import loader from './loader.json';
import splash from './splash.json';

export { loader, splash };
